const advisorTakesEnviromentalCriteria = {
    yes: 'Oui',
    no: 'Non',
};
export default advisorTakesEnviromentalCriteria;
